/**
 * 从 DB 文件名（session id）解析场次日期与城市。
 * 命名示例：260704_呼和浩特 → 2026-07-04 呼和浩特
 */
export function parseSessionMeta(sessionId, displayName = '') {
  const parts = String(sessionId).split('_');
  const dateCode = parts[0] || sessionId;
  const cityName = parts[1] || displayName || sessionId;

  // YYMMDD（6 位数字）
  if (/^\d{6}$/.test(dateCode)) {
    const year = 2000 + parseInt(dateCode.slice(0, 2), 10);
    const month = parseInt(dateCode.slice(2, 4), 10);
    const day = parseInt(dateCode.slice(4, 6), 10);
    return {
      year,
      month,
      day,
      cityName,
      dateLabel: `${month}月${day}日`,
      displayLabel: `${month}月${day}日 ${cityName}`,
      sortKey: dateCode,
    };
  }

  // YYMM 前缀（如 2605bj）
  if (/^\d{4}/.test(dateCode)) {
    const year = 2000 + parseInt(dateCode.slice(0, 2), 10);
    const month = parseInt(dateCode.slice(2, 4), 10);
    const suffix = dateCode.slice(4);
    const name = cityName !== sessionId ? cityName : (suffix || sessionId);
    return {
      year,
      month,
      day: null,
      cityName: name,
      dateLabel: `${month}月`,
      displayLabel: suffix ? name : `${month}月 ${name}`,
      sortKey: dateCode,
    };
  }

  return {
    year: new Date().getFullYear(),
    month: null,
    day: null,
    cityName,
    dateLabel: '',
    displayLabel: displayName || cityName,
    sortKey: '000000',
  };
}

export function buildSessionGroups(sessions) {
  const byYear = {};

  sessions.forEach(session => {
    const meta = parseSessionMeta(session.id, session.name);
    const label = meta.displayLabel;
    const entry = {
      id: session.id,
      label,
      version: session.version,
      ...meta,
    };

    if (!byYear[meta.year]) {
      byYear[meta.year] = [];
    }
    byYear[meta.year].push(entry);
  });

  return Object.keys(byYear)
    .map(year => Number(year))
    .sort((a, b) => b - a)
    .map(year => ({
      year,
      sessions: byYear[year].sort((a, b) => b.sortKey.localeCompare(a.sortKey)),
    }));
}

export function resolveDefaultSessionId(sessions, storedSessionId) {
  if (storedSessionId && sessions.some(s => s.id === storedSessionId)) {
    return storedSessionId;
  }

  const currentYear = new Date().getFullYear();
  const groups = buildSessionGroups(sessions);
  const currentYearGroup = groups.find(g => g.year === currentYear);

  if (currentYearGroup?.sessions.length) {
    return currentYearGroup.sessions[0].id;
  }

  if (groups[0]?.sessions.length) {
    return groups[0].sessions[0].id;
  }

  return sessions[0]?.id || null;
}

export function resolveExpandedYears(yearGroups, activeSessionId) {
  const currentYear = new Date().getFullYear();
  const expanded = { [currentYear]: true };

  if (activeSessionId) {
    const group = yearGroups.find(g =>
      g.sessions.some(s => s.id === activeSessionId)
    );
    if (group) {
      expanded[group.year] = true;
    }
  }

  return expanded;
}
